export const ASSIGN_CARD_TO_USER = 'ASSIGN_CARD_TO_USER';
export const ASSIGN_CARD_TO_USER_SUCCESS = 'ASSIGN_CARD_TO_USER_SUCCESS';

export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';

export const ACTION_ERROR = 'ACTION_ERROR';
